// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"f96f7d17","987":"f96f7d17"}[chunkId] + ".chunk.css";
};